var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.isOpen,"width":"500","persistent":""},on:{"input":_vm.handleChange}},[_c('v-card',[_c('v-card-title',{staticClass:"h2 base-dialog-title",attrs:{"primary-title":""}},[_vm._t("title")],2),_vm._t("body"),_c('v-card-actions',[_c('span',{staticClass:"base-dialog-actions"},[_vm._t("actions")],2)])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }